import React from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmModal({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText
}) {
  const { t } = useTranslation("common");
  const confirmLabel = confirmText ?? t("common.yes");
  const cancelLabel = cancelText ?? t("common.cancel");
  if (!open) return null;

  return (
    <div style={{
      position: "fixed",
      zIndex: 9999,
      left: 0, top: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.15)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        width: 380,
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 4px 28px #0002",
        overflow: "hidden",
        textAlign: "center"
      }}>
        <div style={{
          background: "#00723a",
          color: "#fff",
          fontWeight: 800,
          fontSize: 28,
          padding: "24px 0"
        }}>
          {title}
        </div>
        <div style={{ padding: "32px 30px 10px 30px", fontSize: 18, color: "#00723a" }}>
          {message}
        </div>
        <div style={{
          margin: "28px 0 32px 0",
          display: "flex",
          justifyContent: "center",
          gap: 24
        }}>
          <button
            onClick={onConfirm}
            style={{
              minWidth: 110,
              padding: "12px 0",
              background: "#00723a",
              color: "#fff",
              borderRadius: 7,
              border: "none",
              fontSize: 18,
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            {confirmLabel}
          </button>
          <button
            onClick={onCancel}
            style={{
              minWidth: 110,
              padding: "12px 0",
              background: "#fff",
              color: "#00723a",
              border: "2px solid #00723a",
              borderRadius: 7,
              fontSize: 18,
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
